import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { SeoHelmet, BIO_SEO } from '../seo';

const BIO_GALLERY_IMAGES = [
  {
    src: '/img/facebook/482105346_1584855029122571_1839955921313074007_n.jpg',
    // Recentrage vertical pour garder le haut du visage visible (cover).
    objectPosition: 'center 10%',
    alt: 'Patrick Noah',
  },
  {
    src: '/img/facebook/510927679_9776566105805474_4301671411521862308_n.jpg',
    // Recentrage horizontal pour garder le visage dans le crop "cover".
    objectPosition: 'center 18%',
    alt: 'Patrick Noah en concert',
  },
  {
    src: '/img/facebook/71957290_2274309836031176_6632361250934226944_n.jpg',
    objectPosition: 'center 18%',
    alt: 'Patrick Noah',
  },
];

export function BioPage() {
  return (
    <>
      <SeoHelmet {...BIO_SEO} />

      <Container maxWidth="lg">
      <Box component="article" sx={{ py: 4 }}>
        <Box
          sx={{
            mb: 4,
            // Le layout haut de page ne doit pas faire "carte"
            // : on garde une séparation, mais sans bloc container trop marqué.
            p: { xs: 0, },
          }}
        >
          <Typography variant="h2" color="primary" gutterBottom>
            Biographie
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 600 }}>
            AfroMusicS, Jazz, Afro-cubain et racines africaines : découvrez le parcours de Patrick Noah.
          </Typography>
        </Box>

      <Typography variant="body1" paragraph>
        Né dans la capitale du Cameroun, Patrick Noah débute le chant à l'âge de 11 ans dans la
        chorale de son quartier. En 1989, gravement malade, il reçoit sa première guitare des mains
        de sa mère Técla, qu'il ne quitte plus. Sauvé par un remède de ses aïeux, les médecins
        n'ayant pas diagnostiqué sa maladie, Patrick Noah se remet peu à peu sur pieds et débute une
        série de compositions. La musique traditionnelle et les rappels aux ancêtres sont fréquents
        dans les textes de Patrick Noah. Mêlant sonorités ethniques et modernes, il donne à cette
        synthèse de musiques de racines africaines l'appellation d'AfroMusicS; un genre consistant
        en la fusion d'afro-cubain, latin jazz, afro-caribéen, merengue, salsa, makossa… Pour
        Patrick Noah, cela constitue « … un objectif surtout philosophique, visant à donner à la
        musique africaine la dimension universelle qu'elle mérite en allant puiser à la source dans
        le but de faire profiter le public du magnifique héritage légué par nos ancêtres, Tara :
        ceux qui sont partis en Amérique, dans les Caraïbes, en Europe, ceux qui sont restés en
        Afrique … ».
      </Typography>

      <Box sx={{ mt: 4, mb: 4 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {BIO_GALLERY_IMAGES.map(({ src, objectPosition, alt }) => (
            <Box
              key={src}
              sx={{
                borderRadius: 3,
                overflow: 'hidden',
                height: { xs: 200, md: 240 },
                boxShadow: '0 12px 40px rgba(26, 43, 72, 0.10)',
              }}
            >
              <Box
                component="img"
                src={src}
                alt={alt}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition,
                  display: 'block',
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>

      <Typography variant="body1" paragraph>
        Passionné par la musique cubaine, Patrick Noah a beaucoup travaillé dans ses projets
        artistiques et ses albums avec des musiciens du Septeto Araison ou de Manolito Simonet,
        ainsi qu'avec les groupes Bamboleo, Orishas ou encore Los Papines.
      </Typography>

      <Typography variant="body1" paragraph>
        Chanteur, guitariste, auteur, compositeur, Patrick NOAH joue une musique « tissage » ou
        musique imprégnée de Jazz, d'Afro-cubain et de racines africaines. Pour accompagner le chant
        et les chœurs, les instruments joués en concert sont : la guitare électro-acoustique, la
        guitare « très » cubaine, la guitare électrique, la bass, les percussions, la batterie, les
        maracas, la trompette, le saxophone.
      </Typography>

      <Typography variant="h3" color="primary" sx={{ mt: 4, mb: 2 }}>
        Le parcours de l'artiste
      </Typography>

      <Typography variant="body1" paragraph>
        La musique de Patrick NOAH est le résultat savoureux d'un mélange de rythmes afro cubains,
        Bikutsi du Cameroun, rumba du Congo, guaira, mérengué, rumba, latin jazz … Tous unis par une
        racine commune : l'Afrique.
      </Typography>

      <Typography variant="body1" paragraph>
        Guitariste doué d'une très bonne technique musicale, chanteur enthousiaste et envoûtant,
        Patrick Noah donne à ses prestations d'une sonorité entrainante et d'un style unique. Les
        performances scéniques de Patrick NOAH véhiculent une énergie contagieuse qui invite
        inévitablement son public au mouvement et à la danse. Accompagné de ses musiciens cubains,
        il offre à chaque fois à son auditoire, des concerts de qualité, chaleureux et exaltants.
      </Typography>

      <Typography variant="h3" color="primary" sx={{ mt: 4, mb: 2 }}>
        Patrick Noah
      </Typography>

      <Typography variant="body1" paragraph>
        Le dernier album de Patrick NOAH distribué dans 22 pays (Europe, USA, Japon, Canada…), c'est
        avant tout l'histoire d'une rencontre aussi improbable qu'imprévue entre deux cultures :
        l'une camerounaise avec Patrick Noah, l'autre cubaine, avec Ray Guerrero et son groupe le
        Septeto Araison. Cet album répond à un objectif philosophique qui est cœur de sa quête
        musicale : explorer les musiques qui puisent leur origine dans la musique africaine dans le
        but d'offrir au public l'héritage légué par les ancêtres.
      </Typography>

      <Typography variant="body1" paragraph>
        De cette quête naît, ce que Patrick Noah appelle, l'« AfromusicS ». Ce nouveau concept
        musical s'inspire de toutes les musiques issues du patrimoine musical africain : afro pur,
        jazz, afro-cubain, afro-brésilien, blues, afro-caribéen…
      </Typography>

      <Typography variant="body1" paragraph>
        Défendant les valeurs de solidarité et de métissage, Patrick NOAH a reçu le « prix de la
        citoyenneté pour la pratique culturelle » de la part de Jean Louis Débré, actuel Président
        de la Cour Constitutionnelle en France et ex-Président de l'Assemblée Nationale Française.
        Patrick Noah témoigne via sa musique la dimension universelle et originelle de la musique
        africaine.
      </Typography>

      <Typography variant="h3" color="primary" sx={{ mt: 4, mb: 2 }}>
        L'homme et son histoire
      </Typography>

      <Typography variant="body1" paragraph>
        Patrick Noah est né à Yaoundé en 1973. Depuis sa plus tendre enfance, il est imprégné de
        musique. Vivant dans une société où le chant occupe une place primordiale – on chante la
        joie, la tristesse et aussi pour accompagner les labeurs journaliers – Patrick n'a pas
        échappé à tout cela. Issu d'une famille catholique, pour lui, chanter c'est prier deux
        fois. Dès l'âge de 11 ans il intègre la chorale de son quartier et commence à écrire ses
        premières chansons dont l'une d'elles intitulée « L'école » fut présentée au diplôme de fin
        d'études primaires. En 1989, il reçoit sa première guitare des mains de sa mère, Técla.
      </Typography>

      <Typography variant="body1" paragraph>
        Bercé dans un univers musical, il apprend rapidement, tout seul, à percer les secrets de cet
        instrument pour en acquérir toute la maîtrise et en extraire de nouvelles créations. Guidé
        par sa passion, il fonde son premier groupe avec ses amis de l'université de Yaoundé en
        1991. C'est l'occasion pour lui de pouvoir interpréter ses premières compositions lors de
        concerts donnés dans les salles de Yaoundé. Parallèlement à ses nombreuses activités
        musicales, Patrick Noah suit des études de pharmacie qui vont l'amener en France en 1992.
      </Typography>

      <Typography variant="body1" paragraph>
        Patrick n'a jamais pu concevoir sa vie sans la musique « principale source d'énergie et de
        bonheur ». C'est pourquoi, dès son arrivée à Grenoble, il crée son premier groupe le
        Tropical Gun en 1992 qui deviendra Feeling One Music Africa en 1994. Le besoin de
        retourner à ses origines se fait de plus en plus sentir dans sa musique. C'est pourquoi, il
        choisit, en 1997, de renommer son groupe Akum Be Tara, qui signifie en langue Béti du
        Cameroun « l'héritage des ancêtres ».
      </Typography>

      <Typography variant="body1" paragraph>
        Patrick invente à cette occasion le Concept d'AfromusicS : « … un objectif surtout
        philosophique, visant à donner à la musique africaine la dimension universelle qu'elle
        mérite en allant puiser à la source dans le but de faire profiter le public du magnifique
        héritage légué par nos ancêtres, Tara : ceux qui sont partis en Amérique, dans les
        Caraïbes, en Europe, ceux qui sont restés en Afrique … ».
      </Typography>

      <Typography variant="body1" paragraph>
        Son maxi single 5 titres « Dzal » sorti en mars 2003 se présente comme le fruit de ses
        premières réflexions. Dès sa sortie, il connaît un grand succès au Cameroun et reçoit un
        bel accueil des mélomanes du monde entier notamment à Cuba, en Afrique, en France et au
        Canada. Sa chanson « Lazare » devient en mai 2003 générique d'émission quotidienne sur la
        radio télévision camerounaise. Ses chansons sont également diffusées sur les radios cubaines.
      </Typography>

      <Typography variant="body1" paragraph>
        Son dernier album « Sapéria » sorti chez Playasound/Nocturne est le fruit d'un tissage
        entre la musique du Cameroun et de Cuba.
      </Typography>

      <Typography variant="body1" paragraph>
        Patrick NOAH a aussi collaboré au dernier album du canadien Jean Michelius dans lequel il a
        écrit et composé la chanson « Vincent » ou « Ou ka allé mon Vincent ».
      </Typography>

      <Typography variant="body1" paragraph>
        Son nouvel album « TECLA » (en hommage à sa mère Técla décédée en 2020, où une chanson lui est
        dédiée, le titre « Tecla »), qui mélange Afro Cubain, Jazz et Racines Africaines, a été
        enregistré à La Havane à Cuba avec les amis musiciens cubains de Patrick Noah issus de
        groupes cubains connus comme Bamboleo, El Trabuco (Manolito Simonet) et Los Papines. Le chant
        lead, les chœurs, le mixage final et le mastering ont été réalisés par Patrick Noah au studio
        de la ville des Ulis en France. L'album compte 11 chansons et est chanté en 7 langues (Eton,
        Français, Espagnol, Lingala, Yoruba, Dioula, Créole). L'album a été produit avec le soutien
        financier (crowdfunding) de 109 internautes originaires de 16 pays à travers le monde.
      </Typography>

      <Typography variant="overline" color="primary" sx={{ display: 'block', mt: 4, mb: 1 }}>
        Playlists radio
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Kut Radio Austin USA, France Inter, Africa N°1, Radio Latina, France Bleu Normandie, Radio
        Rebelde Cuba, Radio Planicie Perou, Radio Vexin, ID FM Radio Enghien, Radio Gatine…
      </Typography>

      <Typography variant="overline" color="primary" sx={{ display: 'block', mt: 3, mb: 1 }}>
        Playlists télévisions
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Trace TV, 3A Télésud, Cameroun Radio télévision, Télévision Togo TVT
      </Typography>

      <Typography variant="overline" color="primary" sx={{ display: 'block', mt: 4, mb: 1 }}>
        Prix / distribution
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5, '& li': { mb: 0.5 } }}>
        <li>
          <Typography variant="body2" component="span">
            2005, Lauréat du prix de la citoyenneté pour la pratique culturelle, distinction
            obtenue de Jean Louis Debré, Président de l'Assemblée Nationale Française
          </Typography>
        </li>
        <li>
          <Typography variant="body2" component="span">
            2012, Patrick Noah est musicien « coup de cœur » de la ville des Ulis près de Paris
          </Typography>
        </li>
      </Box>
    </Box>
    </Container>
    </>
  );
}

export default BioPage;
